import http from "./httpService";

const apiEndpoint = "roles";

export function getAllRoles() {
  return http.get(apiEndpoint);
}
